import React from "react";

const FileUpladLoader: React.FC = () => {
    return (
        <div className="fullscreen-popup" id="aiChatPopupLoading">
            <div className="popup-content">
                <p>Belgeleriniz inceleniyor</p>

                <div className="loading-message col-12">

                    <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default FileUpladLoader;
